import { IFilter } from "src/@redux/listRedux";
import commonDataAccess from "../commonDataAccess";

class NonConformaceDataAccess {
  getSubSUbSubNCs(ncId: number) {
    return commonDataAccess.getData("correctiveAction/get/sub-sub-subncs", {
      id: ncId,
    });
  }
  getSubSubNCs(ncId: number) {
    return commonDataAccess.getData("correctiveAction/get/sub-subncs", {
      id: ncId,
    });
  }

  saveSubSubNCs = (payload: any, ncId: any) => {
    return commonDataAccess.postData(
      "correctiveAction/save/sub-subncs",
      payload,
      {
        ncId: ncId,
      },
    );
  };
  deleteSubSubNc = (id: number) => {
    return commonDataAccess.deleteData("correctiveAction/delete/sub-subnc", {
      id: id,
    });
  };

  saveSubSubSubNCs = (payload: any, ncId: any) => {
    return commonDataAccess.postData(
      "correctiveAction/save/sub-sub-subncs",
      payload,
      {
        ncId: ncId,
      },
    );
  };
  deleteSubSubSubNc = (id: number) => {
    return commonDataAccess.deleteData(
      "correctiveAction/delete/sub-sub-subnc",
      {
        id: id,
      },
    );
  };
  getListItems(ncId: any) {
    return commonDataAccess.getData("correctiveAction/get/getListItems", {
      id: ncId,
    });
  }
  getListDropdownByStepId = (stepId: any) => {
    return commonDataAccess.getData(
      "correctiveAction/get/getListDropdownByStepId",
      { stepId: stepId },
    );
  };
  getAssignUsers(ncId: any) {
    return commonDataAccess.getData("correctiveAction/get/assignUsers", {
      ncId: ncId,
    });
  }
  saveAssignUsers(payload: any[], ncId: number) {
    return commonDataAccess.postData(
      "correctiveAction/save/assignUsers",
      payload,
      {
        ncId: ncId,
      },
    );
  }
  getUserToSendEmail(ncId: any) {
    return commonDataAccess.getData("correctiveAction/get/usertosendEmail", {
      ncId: ncId,
    });
  }
  saveUserToSendEmail(ncId: any, payload: any[]) {
    console.log(ncId);
    return commonDataAccess.postData(
      "correctiveAction/save/usertosendEmail",
      payload,
      {
        ncId: ncId,
        // userIds: userIds,
      },
    );
  }
  // getNonConformanceDropdown = (
  //   isCorrectiveAction: boolean,
  //   includeTabletUserSelect: boolean = false,
  // ) => {
  //   return commonDataAccess.getData("correctiveAction/get/dropdownList", {
  //     isCorrectiveAction: isCorrectiveAction,
  //     includeTabletUserSelect: includeTabletUserSelect,
  //   });
  // };
  getNonConformanceDropdown = (
    isCorrectiveAction: boolean,
    includeTabletUserSelect: boolean = false,
    ncTypes: string[] = [],
  ) => {
    return commonDataAccess.getData("correctiveAction/get/dropdownList", {
      isCorrectiveAction,
      includeTabletUserSelect,
      ...(ncTypes.length > 0 && { ncTypes: ncTypes.join(",") }),
    });
  };
  getSubNCDropdownByNC = (ncid: any) => {
    return commonDataAccess.getData(
      `correctiveAction/get/subNcdropdownbyNC/${ncid}`,
    );
  };
  getSubSubNCDropdownByNC = (ncid: any) => {
    return commonDataAccess.getData(
      `correctiveAction/get/subSubNcdropdownbyNC/${ncid}`,
    );
  };
  getSubSubSubNCDropdownByNC = (ncid: any) => {
    return commonDataAccess.getData(
      `correctiveAction/get/subSubSubNcdropdownbyNC/${ncid}`,
    );
  };

  getNCList = (
    params: {
      pageNo;
      pageSize;
      sortData;
      filters: Array<IFilter>;
    },
    moduleName: any,
  ) => {
    let _filters = {};
    params.filters.forEach((item) => {
      if (item.value && item.value.length > 0) {
        _filters["filter." + item.propertyName] = item.value + "-" + item.type;
      }
    });
    let parameters = {
      pageNo: params.pageNo,
      pageSize: params.pageSize,
      sortPreference: params.sortData,
      ..._filters,
    };

    return commonDataAccess.getData(
      "correctiveaction/getall",
      parameters,
      moduleName,
    );
  };
  getBasicInfo = (id: number, moduleName: any) => {
    return commonDataAccess.getData(
      "correctiveAction/get/basicinfo",
      {
        id: id,
      },
      moduleName,
    );
  };
  getSubNcs = (id: number) => {
    return commonDataAccess.getData("correctiveAction/get/subncs", {
      id: id,
    });
  };
  checkNameExists = (name: string, id: any) => {
    return commonDataAccess.getData(
      `correctiveAction/check/name?name=${encodeURIComponent(name)}&id=${id}`,
      {},
      null,
    );
  };
  saveBasicInfo = (payload: any, moduleName: any) => {
    return commonDataAccess.postData(
      "correctiveAction/save/basicinfo",
      payload,
      {},
      null,
      moduleName,
    );
  };
  saveSubNCs = (payload: any, ncId: any) => {
    return commonDataAccess.postData("correctiveAction/save/subncs", payload, {
      ncId: ncId,
    });
  };
  deleteSubNc = (id: number) => {
    return commonDataAccess.postData("correctiveAction/delete/subnc", null, {
      id: id,
    });
  };
  getNcItems = (id: number) => {
    return commonDataAccess.getData("correctiveAction/get/ncitems", {
      id: id,
    });
  };
  getNcItemForDropdown = (ids: any) => {
    return commonDataAccess.getData("correctiveAction/get/ncitemsfordropdown", {
      ids: ids,
    });
  };
  saveNcItems = (payload: any, ncId: any) => {
    return commonDataAccess.postData("correctiveAction/save/ncitems", payload, {
      ncId: ncId,
    });
  };
  saveListItems = (payload: any) => {
    return commonDataAccess.postData(
      "correctiveAction/save/listitems",
      payload,
    );
  };
  deleteNcItem = (id: number) => {
    return commonDataAccess.postData("correctiveAction/delete/ncitem", null, {
      id: id,
    });
  };
  deleteNcById = (ids: string, moduleName: string) => {
    console.log(ids);
    return commonDataAccess.deleteData("correctiveAction/delete/nc", {
      ids: ids,
      moduleName,
    });
  };

  saveNcItemSequence = (
    ncId: number,
    nCItemId: number,
    prevPos: number,
    currentPos: number,
  ) => {
    return commonDataAccess.postData(
      "correctiveAction/update/NCItemSequenceposition",
      null,
      {
        ncId: ncId,
        nCItemId: nCItemId,
        previousSeqNo: prevPos,
        currentSequenceNo: currentPos,
      },
    );
  };

  getSiteItems = (id: number) => {
    return commonDataAccess.getData("correctiveAction/get/siteitems", {
      id: id,
    });
  };

  saveSiteItems = (payload: any, ncId: any) => {
    return commonDataAccess.postData(
      "correctiveAction/save/siteitems",
      payload,
      {
        ncId: ncId,
      },
    );
  };
  getSiteEmailReciepents = () => {
    return commonDataAccess.getData("correctiveAction/get/siteEmailReciepents");
  };
  getSiteDropdown = () => {
    return commonDataAccess.getData(
      "correctiveAction/get/siteitems-dropdownlist",
    );
  };
  sendNCREmail = (emails: any[], organizationId: any, jobId: any) => {
    return commonDataAccess.postData(
      `email/send/NCREmail`,
      {
        organizationId,
        jobId,
        emails,
      },
      {},
      "Legacy",
    );
  };

  copyNC = (ids: string) => {
    return commonDataAccess.postData("correctiveAction/copy", null, {
      ids,
    });
  };
}

export default new NonConformaceDataAccess();
